import { Pagination } from './ReactAdminPagination';

const CustomPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100, 500]} defaultValue={50} {...props} />
);

export default CustomPagination;
